import update from 'immutability-helper'

/*
 * 修改商品列表 config
 */
export function setProductsList(node: any, action) {
  return update(node, {
    config: {
      [action.name]: {
        $set: action.data,
      },
    },
  })
}
